<template>
  <div class="Report">
    <h3 class="mb-3 text-right">reporte de depósito</h3>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              Ingresa los datos de la transferencia
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text class="scroll">
        <b-list-group class="p-2">
          <b-container>
            <b-row>
              <b-col lg="6" class="mb-3">

                  
                
                <b-row align-h="center">
                    <b-col lg="10" md="10" sm="10" cols="12">
                    <h3
                      class="text-light-black text-left"
                      style="font-size: 20px"
                    >
                      Cuenta bancaria del usuario
                    </h3>
                  </b-col>
                  <!-- <b-col lg="7" md="7" sm="7" cols="12">
                    <b-form-select
                      id="input-live"
                      v-model="Companybank_id"
                      :options="bankCompany"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      trim
                    ></b-form-select>
                  </b-col> -->
                  <b-col lg="10" md="10" sm="10" v-if="bankData">
                    <div class="text-light-black text-left">
                      {{ bankData.name }}
                    </div>
                    <div class="text-light-black text-left">
                      Número de cuenta: {{ bankData.number }}
                    </div>
                    <div class="text-light-black text-left">
                      {{ bankData.email }}
                    </div>
                    <div class="text-light-black text-left">
                      ACH: {{ bankData.ach }} <br />
                      {{ type_account }}
                    </div>
                  </b-col>
                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black text-left mt-3">Monto</h5>
                    <b-form-input
                      id="input-live"
                      v-model="amount"
                      type="number"
                      size="sm"
                      min="0"
                      class="shadow-sm bg-white rounded"
                      trim
                    ></b-form-input>
                  </b-col>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black mt-3 text-left">
                      Fecha de depósito
                    </h5>
                    <b-form-datepicker
                      class="text-left"
                      id="datepicker-dateformat"
                      :date-format-options="{
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        weekday: 'short',
                      }"
                      locale="es"
                      placeholder="Fecha de depósito"
                      v-model="date_pay_select"
                    ></b-form-datepicker>
                  </b-col>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black mt-3 text-left">
                      Número de confirmación
                    </h5>

                    <b-form-input
                      v-model="RefNumber"
                      id="RefNumber"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="6" md="6" sm="9" cols="12"> </b-col>
                  <div></div>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black mt-3 text-left">
                      Banco de la compañia
                    </h5>
                    <b-form-select
                      id="input-live"
                      v-model="Companybank_id"
                      :options="bankCompany"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      trim
                    ></b-form-select>
                  </b-col>
                  
                </b-row>
              </b-col>
              <b-col lg="6">
                

                <b-row align-v="center" align-h="center" class="mt-5">
                  <b-col lg="6">
                    Adjuntar el comprobante
                    <b-button
                      variant="white"
                      v-if="!picture"
                      @click="changePicture()"
                    >
                      <svg
                        class="p-5 shadow-lg"
                        style="background-color: #f8f8f8; border-radius: 10px"
                        xmlns="http://www.w3.org/2000/svg"
                        height="200px"
                        viewBox="0 0 24 24"
                        width="200px"
                        fill="#C4C4C4"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                        />
                      </svg>
                    </b-button>

                    <img
                      v-if="picture"
                      :src="picture"
                      height="200px"
                      width="200px"
                      style="border-radius: 10px"
                      alt=""
                    />
                    <b-button
                      @click="changePicture()"
                      v-if="picture"
                     class="btn-card-color mt-3"
                      style="border-radius: 8px; border: none"
                    >
                      <span class="text-font-white"> Cambiar</span>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <b-button
                      style="border-radius: 8px; border: none"
                      class="btn-card-color mt-3 text-left pl-5 pr-5 pb-2 pt-2"
                      size="lg"
                      @click="reportPayment()"
                    >
                      <span
                        v-if="!progress"
                        class="text-font-white"
                        style="font-size: 18px"
                        >Reportar depósito</span
                      >
                      <span v-if="progress" class="text-font-white"
                        ><b-spinner type="grow" label="Spinning"></b-spinner
                        >Cargando</span
                      >
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Report",
  data() {
    return {
      id_account_transaction: null,
      id_userBank: null,
      progress: false,
      amount: "",
      date_pay_select: null,
      Companybank_id: null,
      RefNumber: "",
      picture: null,
      file1: null,
      id: Cookies.get("id"),
      disable: null,
      title: "",
      info_wd: [],
      bankCompany: [],
      bankData: [],
      type_account: "",
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
      main_account: (state) => state.main_account,
    }),
    checkAuth() {
      return this.code2.length == 6 ? false : true;
    },
  },
  mounted() {
    console.log(this.$route.params.id);
    this.AllCompanyBank();
    this.WithdrawInfo()
  },

  methods: {
    ...mapActions([
      "getTransactionById",
      "StorePayment",
      "getCompanyBank",
      "getCompanyBankbyId",
    ]),
    resetModal() {
      this.step1 = 1;
    },
    WithdrawInfo(){
        this.id_account_transaction = this.$route.params.id
        this.getTransactionById(this.id_account_transaction)
        .then(response => {
            if ( response.code == 200 ){
                this.info_wd = response.data
                this.bankData = response.data.bank
                this.type_account = response.data.bank.type.name
                this.amount = response.data.amount
                this.id_userBank = response.data.user_bank_id
            }
        })
        .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
    },
    
    AllCompanyBank() {
      this.getCompanyBank().then((response) => {
        if (response.code == 200) {
          response.data.forEach((element) => {
            this.bankCompany.push({
              value: String(element.id),
              text: element.name,
            });
          });
        }
      });
    },

    reportPayment() {
        console.log(this.amount, this.date_pay_select, this.RefNumber)
      if (
        this.date_pay_select == null ||
        this.RefNumber == "" || 
        this.amount == ""
      ) {
        Swal.fire({
          title: "Atención",
          text: "Debes llenar todos los campos para continuar",
          icon: "warning",
        });
      } else {
        if (this.amount <= 0) {
          Swal.fire({
            title: "Atención",
            text: "El monto a registrar debe ser mayor a 0",
            icon: "warning",
          });
        } else if (!this.picture) {
          Swal.fire({
            title: "Atención",
            text: "Debe adjuntar un comprobante del voucher",
            icon: "warning",
          });
        } else {
          this.progress = true;
          let datos = new FormData();
          datos.append("account_transaction_id", this.id_account_transaction);
          datos.append("company_bank_id", this.Companybank_id);
          datos.append("payment_method_id", "2");
          datos.append("amount", this.amount);
          datos.append("reference", this.RefNumber);
          datos.append("date_payment", this.date_pay_select);
          datos.append("voucher", this.file1);
          datos.append("user_bank_id", this.id_userBank);

          this.StorePayment(datos)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Tu depósito ha sido reportado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                    timer: 1500,
                })
                this.$router.push('/admin/withdraw_reports')
              } else if (response.code == 400) {
                Swal.fire({
                  title: "Atención",
                  text: "Error en las validaciones",
                  icon: "warning",
                });
                this.progress = false;
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
        }
      }
    },
    async changePicture() {
      const { value: file } = await Swal.fire({
        title: "Seleccionar una imagen",
        input: "file",
        inputAttributes: {
          accept: "image/*",
          "aria-label": "Upload your profile picture",
        },
      });

      if (file) {
        this.progress = true;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.picture = e.target.result;
          this.file1 = file;
          this.progress = false;
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>
<style scoped>
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
a {
  color: #CF173C !important;
}

</style>